import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Clinicas from "./pages/Clinicas";
import ClinicDetail from "./pages/ClinicDetail";
import RegisterClinic from "./pages/RegisterClinic";
import TermsConditions from "./pages/TermsConditions";
import { Toaster } from "./components/ui/toaster";
import { CountryProvider } from "./context/CountryContext";
import { DataProvider } from "./context/DataContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <DataProvider>
          <CountryProvider>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/clinicas" element={<Clinicas />} />
              <Route path="/clinicas/:id" element={<ClinicDetail />} />
              <Route path="/registrar-clinica" element={<RegisterClinic />} />
              <Route path="/terminos-condiciones" element={<TermsConditions />} />
            </Routes>
            <Footer />
            <Toaster />
          </CountryProvider>
        </DataProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
